import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { SubmitProposalClientResponse } from '../@types/SubmitProposal'

type Store = {
  isSubmitProposalRequested: boolean
  setIsSubmitProposalRequested: (value: boolean) => void
  submitProposal: SubmitProposalClientResponse | null
  setSubmitProposal: (value: SubmitProposalClientResponse) => void
}

export const useSubmitProposalStore = create<Store>()(
  devtools(
    (set) => ({
      isSubmitProposalRequested: false,
      setIsSubmitProposalRequested: (isSubmitProposalRequested) =>
        set({ isSubmitProposalRequested }),
      submitProposal: null,
      setSubmitProposal: (submitProposal) => set({ submitProposal }),
    }),
    { name: 'SubmitProposalStore' },
  ),
)
